import React, { useRef, useEffect, useState } from "react";

const Payment = ({ env, config }) => {
  const paymentContainer = useRef(null);
  const paymentForm = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    console.log("config", config);

    var scriptTag = document.createElement("script");
    scriptTag.src =
      env ||
      "https://dev-kpaymentgateway.kasikornbank.com/ui/v2/kinlinepayment.min.js";

    // on script loaded
    scriptTag.onload = function () {
      console.log("Script loaded and ready");

      // config Payment Value
      window.KInlineCheckout.configure({
        ...config,
      });

      window.KInlineCheckout.onInputValidation((element, message) => {
        if (message === "invalid") {
          document.getElementById(element).classList.add("is-danger");
        } else {
          document.getElementById(element).classList.remove("is-danger");
        }
      });

      window.KInlineCheckout.onPaymentTimeout((error) => {
        console.log(error);
        alert(JSON.stringify(error));
        buttonRef.current.disabled = true;
      });
    };

    // add to html
    paymentContainer.current.appendChild(scriptTag);

    return () => {
      console.log("unmount");
      paymentContainer.current.removeChild(scriptTag);
    };
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    window.KInlineCheckout.getToken()
      .then((result) => {
        console.log(result);

        alert(JSON.stringify(result));
      })
      .catch((error) => {
        console.log(error);
        alert(JSON.stringify(error));
      });
  };

  return (
    <>
      <div className="box">
        <div className="bd-index-custom-example" ref={paymentContainer}>
          <h1 className="title">PAYMENT SECTION</h1>

          <div className="field">
            <label className="label">Card Number</label>
            <div className="control">
              <div id="card-number" className="input"></div>
            </div>
          </div>

          <div className="field">
            <label className="label">Card Name</label>
            <div className="control">
              <div id="card-name" className="input"></div>
            </div>
          </div>

          <div className="field is-horizontal">
            <div className="field-body">
              <div className="field">
                <label className="label">Card Expiry</label>
                <div className="control is-expanded">
                  <div id="card-expiry" className="input"></div>
                </div>
              </div>
              <div className="field">
                <label className="label">Card CVV</label>
                <div className="control is-expanded">
                  <div id="card-cvv" className="input"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="field">
            <div className="control">
              <div id="remember-card"></div>
            </div>
          </div>

          <form onSubmit={handleSubmit} ref={paymentForm}>
            <button type="submit" className="button is-primary" ref={buttonRef}>
              Submit
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Payment;
